import React from "react";
import Carousel from "react-bootstrap/Carousel";
import Hero_Image_1 from "../../assets/images/substation.jpg";
import Hero_Image_2 from "../../assets/images/gear.jpg";
import Hero_Image_3 from "../../assets/images/hero_image_3.jpg";
import section_image_1 from "../../assets/images/section_image_1.png";
import HeroSection from "../../components/HeroSection/HeroSection";
import RightSection from "../../components/RightSection/RightSection";
import Reviews from "../../components/Reviews/Reviews";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import SocialMedia from "../../components/SocialMedia/SocialMedia";
import Products from "../../components/Products/Products";
import "./Home.css";
import InHouse from "../../components/InHouse/InHouse";
import Button from "../../components/Button/Button";
// import NewsSection from "../../components/NewsSection/NewsSection";
import Map from "../../components/Map/Map";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import { Helmet } from "react-helmet";

export default function Home() {
  return (
    <div>
      <Helmet>
        <meta property="og:type" content="website" />
        <meta name="description"
          content="A highly successful and experienced trading and construction company, specialising in - supply only & full EPC turnkey, construction of electrical transmission, distribution network systems to power utilities, contractors and construction companies in Africa." />
        <meta
          property="og:title"
          content="Elegro Energy Limited | Trading and Construction Company"
        />
        <meta
          property="og:description"
          content="A highly successful and experienced trading and construction company, specialising in - supply only & full EPC turnkey, construction of electrical transmission, distribution network systems to power utilities, contractors and construction companies in Africa."
        />
        <meta
          property="og:image"
          content="https://www.elegroenergyltm.com/static/media/section_image_3.1c18d82e8dd104c3322d.png"
        />
        <meta property="og:url" content="https://www.elegroenergyltm.com/" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="/" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Carousel controls={false} interval={6000}>
        <Carousel.Item>
          <HeroSection
            heroTitle="Elegro Energy  Limited."
            heroParagraph="A highly successful and experienced trading and construction company."
            btnLink="/projects"
            btnText="View Projects"
            heroImage={Hero_Image_1}
          />
        </Carousel.Item>
        <Carousel.Item>
          <HeroSection
            heroTitle="International experience."
            heroParagraph="International experience in Letters of Credit and other forms of contracts."
            btnLink="/projects"
            btnText="View Projects"
            heroImage={Hero_Image_2}
          />
        </Carousel.Item>
        <Carousel.Item>
          <HeroSection
            heroTitle="Extensive network."
            heroParagraph="Extensive network of qualified and certified suppliers and manufacturers"
            btnLink="/projects"
            btnText="View Projects"
            heroImage={Hero_Image_3}
          />
        </Carousel.Item>
      </Carousel>
      <RightSection
        MainHeader="ABOUT US"
        Subtitle="Elegro Energy Limited"
        Paragraph="ELEGRO ENERGY LIMITED was known as ROUSANT INTERNATIONAL, it was started by some engineers who didn’t want to just work as engineers and that’s it. They started because they wanted to do something of their own,something that involves what they love and what could keep them running for years. We started a business that involves what we love and doing what we love."
        btnLink="/aboutus"
        btnText="More About Us"
        SideImage={section_image_1}
      />
      <Reviews />
      <ServiceSection />
      <ProjectSection />
      <SocialMedia />
      <Products />
      <div className="reach_out">
        <div className="container padding_top_bottom">
          <h2>Do you want to work with us? Do get In touch.</h2>
          <Button btnLink="/getintouch" btnText="Get In Touch" />
        </div>
      </div>
      <InHouse />
      {/* <NewsSection /> */}
      <Map />
      <GetInTouch />
    </div>
  );
}
